import React from 'react';
import {ListGroup, Form, Card} from 'react-bootstrap';
import useCheckFilterFieldsValidity from '../../util/useCheckFilterFieldsValidity';
import Filter from './Filter';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';

const FilterSingleSelectList = (props) => {
    const checkFieldsValidity = useCheckFilterFieldsValidity();
    return <Filter
        key={`filter-${props.filter.name}`}
        filters={props.filters}
        setFilters={props.setFilters}
        loading={props.loading}
        filter={props.filter}
        filtersInitial={props.filtersInitial}
    >
        <style>
            {
                `
                    .form-control.is-invalid {
                        padding-right: 0.75rem;
                        background-image: none;
                    }
                `
            }

        </style>
        <Card
            style={
                {
                    ...(
                        !props.filter.valid ?
                            {
                                borderColor: `#dc3545`,
                                boxShadow: `0 0 0 .2rem rgba(220,53,69,.25)`
                            } :
                            {
                                boxShadow: 'none',
                                borderColor: 'rgba(0,0,0,0.125)'
                            }
                    )
                }
            }
        >
            <ListGroup
                variant="flush"
            >
                {
                    props.filter.config.options.map((option) => {
                        return <ListGroup.Item
                            key={option}
                        >
                            <Form.Check
                                style={
                                    {
                                        cursor: 'pointer'
                                    }
                                }
                                type="radio"
                                disabled={props.loading}
                                label={
                                    <span
                                        style={
                                            {
                                                userSelect: 'none',
                                                cursor: 'pointer',
                                            }
                                        }
                                    >{props.APIOptions[option]}</span>
                                }
                                value={option.value}
                                name={props.filter.name}
                                checked={option.value === props.filter.value}
                                onChange={
                                    () => {
                                        const othersValid = checkOtherFiltersValid(props.filter, props.filters);
                                        const filterValidity = checkFieldsValidity(option.value, props.filter.validation);

                                        props.setFilters(
                                            {
                                                ...props.filters,
                                                changed: true,
                                                valid: othersValid && filterValidity.valid,
                                                filters: {
                                                    ...props.filters.filters,
                                                    [props.filter.name]: {
                                                        ...props.filter,
                                                        value: option,
                                                        valid: filterValidity.valid,
                                                        touched: true,
                                                        errors: filterValidity.errors
                                                    }
                                                }
                                            }
                                        );
                                    }
                                }
                                id={`props.filter.name-option-${option.value}`}
                            />
                        </ListGroup.Item>
                    })
                }
            </ListGroup>
        </Card>
    </Filter>
}

export default FilterSingleSelectList;
